import React, { useState } from 'react';
import { toogleReload } from '../../../Utils/reloadSlice';
import { useDispatch } from 'react-redux';

const Affiliates = ({ data }) => {
    const [loading, setLoading] = useState(false);
    const clipBoard = navigator.clipboard;
    const dispatch = useDispatch();

    const handleDelete = (id) => {
        setLoading(true);
        const deleteUrl = `https://api.mokx.org/api/v1/affiliate/${id}`;
        // Create a DELETE request
        fetch(deleteUrl, {
          method: 'DELETE',
        })
        .then((response) => {
          if (response.ok) {
            alert('Affiliate deleted successfully');
            dispatch(toogleReload());
          } else {
            console.error('Failed to delete resource');
          }
        })
        .catch((error) => {
          // Handle network errors
          console.error('Network error:', error);
        });
        setLoading(false);
    }

    const handleCopy = (link) => {
      clipBoard.writeText(link).then(() => {
        alert("Copied text to clipboard successfully");
      });
    }

    return (
        <div key={data.id} className="relative lg:w-[48%] md:w-[48%] w-[100%] bg-[#FFF] rounded-xl drop-shadow-3Xl py-7 pr-9 pl-10 mb-4 flex flex-col justify-center gap-4">
            <h1 className='text-[#000] text-2xl font-figtree font-semibold'>{data.affiliateCode}</h1>
            <div className='text-[#000] text-xl font-figtree font-medium'>{data.affiliateName}</div>
            <div className='text-[#263fb3] text-lg font-figtree font-medium flex gap-3'>
                {data.link}
                <div className='cursor-pointer' onClick={() => handleCopy(data.link)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path fill="none" stroke="#717171" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.4" d="M20.829 12.861c.171-.413.171-.938.171-1.986s0-1.573-.171-1.986a2.25 2.25 0 0 0-1.218-1.218c-.413-.171-.938-.171-1.986-.171H11.1c-1.26 0-1.89 0-2.371.245a2.25 2.25 0 0 0-.984.984C7.5 9.209 7.5 9.839 7.5 11.1v6.525c0 1.048 0 1.573.171 1.986c.229.551.667.99 1.218 1.218c.413.171.938.171 1.986.171s1.573 0 1.986-.171m7.968-7.968a2.25 2.25 0 0 1-1.218 1.218c-.413.171-.938.171-1.986.171s-1.573 0-1.986.171a2.25 2.25 0 0 0-1.218 1.218c-.171.413-.171.938-.171 1.986s0 1.573-.171 1.986a2.25 2.25 0 0 1-1.218 1.218m7.968-7.968a11.678 11.678 0 0 1-7.75 7.9l-.218.068M16.5 7.5v-.9c0-1.26 0-1.89-.245-2.371a2.25 2.25 0 0 0-.983-.984C14.79 3 14.16 3 12.9 3H6.6c-1.26 0-1.89 0-2.371.245a2.25 2.25 0 0 0-.984.984C3 4.709 3 5.339 3 6.6v6.3c0 1.26 0 1.89.245 2.371c.216.424.56.768.984.984c.48.245 1.111.245 2.372.245H7.5"/>
                    </svg>
                </div>
            </div>
            <div className='absolute right-1 top-1 cursor-pointer flex gap-1'>
                {/* <button disabled={loading}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
                    <path fill={loading? "#86B0F4":"#286de0"} d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10s10-4.47 10-10S17.53 2 12 2m3.1 5.07c.14 0 .28.05.4.16l1.27 1.27c.23.22.23.57 0 .78l-1 1l-2.05-2.05l1-1c.1-.11.24-.16.38-.16m-1.97 1.74l2.06 2.06l-6.06 6.06H7.07v-2.06l6.06-6.06Z"/>
                    </svg>
                </button> */}
                <button disabled={loading} onClick={() => handleDelete(data.id)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
                    <path fill={loading? "#FB9883":"#E23712"} d="M12 2c5.53 0 10 4.47 10 10s-4.47 10-10 10S2 17.53 2 12S6.47 2 12 2m5 5h-2.5l-1-1h-3l-1 1H7v2h10V7M9 18h6a1 1 0 0 0 1-1v-7H8v7a1 1 0 0 0 1 1Z"/>
                    </svg>
                </button>
            </div>
        </div>
    )
}

export default Affiliates;